

import React from 'react';

const Team = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Travel Guides
          </h6>
          <h1 className="mb-5">Meet The Outpost Gentlemen </h1>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-1.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                {/* <a className="btn btn-square mx-1" href="#">
                    <i className="fab fa-facebook-f" />
                  </a> */}
                <a className="btn btn-square mx-1" href="http://linkedin.com/in/david-murphy-93791610">
                  <i className="fab fa-linkedin-in" />
                </a>
                <a className="btn btn-square mx-1" href="https://www.instagram.com/theoutposttravels/">
                  <i className="fab fa-instagram" />
                </a>
                <a className="btn btn-square mx-1" href="https://www.foratravel.com/advisor/david-murphy">
                  <i className="fab fa-building" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">David</h5>
                <small> Certified Fora Travel Advisor</small>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-2.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                {/* <a className="btn btn-square mx-1" href="#">
                    <i className="fab fa-facebook-f" />
                  </a> */}
                <a className="btn btn-square mx-1" href="/">
                  <i className="fab fa-linkedin-in" />
                </a>

                <a className="btn btn-square mx-1" href="https://www.instagram.com/theoutposttravels/">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Jarrod</h5>
                <small>Associate Advisor </small>
                <small>CoFounder - CTO</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
